<!DOCTYPE html>
<div class="modal-container">
    <div class="modal-wrapper">
        <img src="assets\images\confetti.png" alt="" loading="lazy">
        <h2 class="modal-title"> {{ "exit-point-confirmation-popup.title" | translate }} </h2>
        <p class="sub-heading"> {{"exit-point-confirmation-popup.get" | translate }} <b>{{this.offerData?.lines}}</b>
            {{"exit-point-confirmation-popup.line" | translate }} <b> {{ currencySymbol
                }}{{this.offerData?.price}}</b> {{"exit-point-confirmation-popup.play" | translate }} </p>
        <p class="amount">

        </p>
        <p class="sub-heading">{{ "exit-point-confirmation-popup.subHeading" | translate }} </p>
        <button type="button" class="btn btn-light" (click)="close()"> {{this.offerData?.lines}}
            {{"exit-point-confirmation-popup.button-text" | translate }} {{
            currencySymbol
            }}{{this.offerData?.price}} </button>
        <p class="skip" (click)="backToPreviousPage()"> {{ "exit-point-confirmation-popup.skip" | translate }} </p>
    </div>
</div>
